import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import ActionsMenu from "@/components/dashboard/ActionsMenu";
import { getCurrentDateGMT5 } from "@/utils/timezone";
import { Fact } from "../types";

export interface FactColumnOptions {
  onEdit: (fact: Fact) => void;
  onDelete: (fact: Fact) => void;
  canDelete?: boolean;
}

export function createFactsColumns(options: FactColumnOptions): ColumnDef<Fact>[] {
  return [
    { accessorKey: "id", header: "ID" },
    { accessorKey: "title", header: "Title" },
    {
      accessorKey: "scheduled_date",
      header: "Scheduled Date",
      cell: ({ row }) => {
        const scheduledDate = row.getValue("scheduled_date") as string;
        if (!scheduledDate) {
          return <span className="text-muted-foreground">Not scheduled</span>;
        }
        return <span>{scheduledDate}</span>;
      },
    },
    {
      accessorKey: "is_tod",
      header: "Fact of the day",
      cell: ({ row }) => {
        const fact = row.original;
        const isTod = !!fact.is_tod;
        if (isTod) {
          return <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">Active</span>;
        }
        const raw = fact.scheduled_date_raw;
        const today = getCurrentDateGMT5();
        const isPast = raw && raw < today;
        if (isPast) {
          return <span className="px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">In Library</span>;
        }
        return <span className="px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-600">Scheduled</span>;
      },
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      cell: ({ row }) => <span>{(row.getValue("created_at") as string) || ""}</span>,
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const fact = row.original;
        return (
          <ActionsMenu
            onEdit={() => options.onEdit(fact)}
            onDelete={options.canDelete ? () => options.onDelete(fact) : undefined}
            disabledDelete={!options.canDelete}
          />
        );
      },
    },
  ];
}
